import React from "react"
import aos from 'aos';

import Layout from "../components/layout"
import SEO from "../components/seo"

import Hero from "../components/Hero"
import Icons from "../components/Icons"
import Clients from "../components/Clients"
import Access from "../components/Access"
import Ready from "../components/Ready"

import "../assets/stylesheets/index.scss"
import 'aos/dist/aos.css';

export default class IndexPage extends React.Component {
  componentDidMount() {
    aos.init({
      once: true,
      duration: 1000,
    })
  }
  render() {
    return (
      <Layout>
        <SEO title="Graj na zdrowie" description="Unikatowy system motywujący pomoże Ci zaplanować dzień tak, aby znalazł się czas na wszystko. Wykonuj ćwiczenia, zdobywaj odznaki jednocześnie czuwając nad stanem swojego zdrowia." keywords={['mukoapp', 'mukowiscydoza', 'graj na zdrowie']} />
        <Hero />
        <Icons />
        <Clients />
        <Access />
        <Ready />
      </Layout>
    )
  }
}
